import React from 'react';

import { useGlobalStore } from '../../stores/useGlobalStore';

import { HomepageOnboardingLauncher } from './launcher/HomepageOnboardingLauncher';

export const OnboardingRoot: React.FC = () => {
  const activeOnboardingKey = useGlobalStore((state) => state.activeOnboardingKey);

  switch (activeOnboardingKey) {
    case 'home':
      return <HomepageOnboardingLauncher />;
    default:
      return null;
  }
};
